import { createFileRoute } from '@tanstack/react-router'

import { paginaObrigatoria } from '@/lib/visoes'

import { PaginaComAbas } from '@/components/heimdall/pagina-com-abas'

import { AbaComentariosQa } from '@/features/qualidade-comentarios/aba'
import { AbaNotaQa } from '@/features/qualidade-nota/aba'
import { AbaWikis } from '@/features/qualidade-wikis/aba'

export const Route = createFileRoute('/$perfil/qualidade')({
  component: Tela,
})

/** Qualidade: nota de QA, comentários de QA e wikis. Cada aba vem da pasta da sua peça. */
function Tela() {
  return (
    <PaginaComAbas
      pagina={paginaObrigatoria('qualidade')}
      abas={[
        { id: 'nota', titulo: 'Nota de QA', conteudo: <AbaNotaQa /> },
        { id: 'comentarios', titulo: 'Comentários', conteudo: <AbaComentariosQa /> },
        { id: 'wikis', titulo: 'Wikis', conteudo: <AbaWikis /> },
      ]}
    />
  )
}
